import {
    GET_SITE_VISIT_FORM_DETAILS_FAILURE,
    GET_SITE_VISIT_FORM_DETAILS_LOADING,
    GET_SITE_VISIT_FORM_DETAILS_SUCCESS,
  } from "../../actions/types";
  
  const initialState = {
    siteVisitFormDetails: {
      get: {
        loading: false,
        success: {
          ok: false,
          data: null,
        },
        failure: {
          error: false,
          message: "",
        },
      },
    },
  };
  
  const getSiteVisitFormDetailsReducers = (state = initialState, action) => {
    switch (action.type) {
      case GET_SITE_VISIT_FORM_DETAILS_LOADING:
        return {
          ...state,
          siteVisitFormDetails: {
            ...state.siteVisitFormDetails,
            get: {
              ...state.siteVisitFormDetails.get,
              loading: true,
              reset: false,
              success: {
                ...state.siteVisitFormDetails.get.success,
                ok: false,
              },
              failure: {
                error: false,
                message: "",
              },
            },
          },
        };
  
      case GET_SITE_VISIT_FORM_DETAILS_SUCCESS:
        return {
          ...state,
          siteVisitFormDetails: {
              ...state.siteVisitFormDetails,
              get: {
                  ...state.siteVisitFormDetails.get,
                  loading: false,
                  reset: false,
                  success: {
                      ...state.siteVisitFormDetails.get.success,
                      ok: true,
                      data: action.payload,
                  },
                  failure: {
                      error: false,
                      message: '',
                  },
              },
          },
        };
      case GET_SITE_VISIT_FORM_DETAILS_FAILURE:
        return {
          ...state,
          siteVisitFormDetails: {
              ...state.siteVisitFormDetails,
              get: {
                  ...state.siteVisitFormDetails.get,
                  loading: false,
                  reset: false,
                  success: {
                      ...state.siteVisitFormDetails.get.success,
                      ok: false,
                      data: null,
                  },
                  failure: {
                      error: true,
                      message: action.payload.message,
                  },
              },
          },
        };
      default:
        return state;
    }
  };
  
  export default getSiteVisitFormDetailsReducers;
  